import { render, staticRenderFns } from "./purchaseStockIn-add-or-update.vue?vue&type=template&id=68b28638&scoped=true"
import script from "./purchaseStockIn-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseStockIn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseStockIn-add-or-update.vue?vue&type=style&index=0&id=68b28638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b28638",
  null
  
)

export default component.exports